import * as React from 'react';
import { capitalize } from 'lodash';

import { ModalFrame, ModalFrameFooter, ModalFrameInner } from 'components/modal';
import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';
import { addThousandsSeparator } from 'utils/helper/common';

import './subcampaign-variable-payments-modal.scss';

import type { VariablePayment } from 'types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./subcampaign-variable-payments-modal.i18n.json'));

type Props = {
  campaignName: string,
  variablePayments: Array<VariablePayment>,
  variablePaymentsAmount: number,
  onCloseModal: () => void
};

const msgKey = 'subcampaign_variable_payments_modal';

class SubcampaignVariablePaymentsModal extends React.PureComponent<Props> {
  renderButtons(): React.ReactNode {
    const { onCloseModal } = this.props;

    return (
      <ModalFrameFooter>
        <ActionButton
          color="secondary"
          onClick={onCloseModal}
        >
          {__t('collabary_common.action_button.close')}
        </ActionButton>
      </ModalFrameFooter>
    );
  }

  renderBody(): React.ReactNode {
    const { variablePayments } = this.props;

    return (
      <div className="subcampaign-variable-payments-modal__items">
        <div className="subcampaign-variable-payments-modal__header">
          <div>
            {__t(`${msgKey}.description_title`)}
          </div>
          <div>
            {__t(`${msgKey}.amount_title`)}
          </div>
        </div>
        {
          variablePayments.map((item: VariablePayment) => (
            <div
              key={item.id}
              className="subcampaign-variable-payments-modal__item"
            >
              <div>
                {capitalize(item.description)}
              </div>
              <div>
                {addThousandsSeparator(item.amount)}
              </div>
            </div>
          ))
        }
      </div>
    );
  }

  renderTotal(): React.ReactNode {
    const { variablePaymentsAmount } = this.props;

    return (
      <div className="subcampaign-variable-payments-modal__total">
        {__t(`${msgKey}.total`)}{addThousandsSeparator(variablePaymentsAmount)}
      </div>
    );
  }

  render(): React.ReactNode {
    const { campaignName } = this.props;

    return (
      <ModalFrame
        title={__t(`${msgKey}.title`)}
        subtitle={`”${campaignName}”`}
        data-qa="subcampaign-variable-payments-modal"
      >
        <ModalFrameInner>
          <div
            className="subcampaign-variable-payments-modal"
            data-qa="subcampaign-variable-payments-modal"
          >
            {this.renderBody()}
            {this.renderTotal()}
          </div>
        </ModalFrameInner>
        {this.renderButtons()}
      </ModalFrame>
    );
  }
}

export default SubcampaignVariablePaymentsModal;
